import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Hourlystats = () => {
  const [hourlystats, setHourlystats] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`hourlystats?page=${page}`);
      setHourlystats(data.data);
      setLastPage(data.meta.last_page);
    })();
  }, [page]);
  const del = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      await axios.delete(`hourlystats/${id}`);
      setHourlystats(hourlystats.filter((hourlystat) => hourlystat.id !== id));
    }
  };
  return (
    <Wrapper pageTitle={"Hourly Stats"}>
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                <th className="px-4 py-3">#Ref </th>
                <th className="px-4 py-3">Report Date </th>
                <th className="px-4 py-3">Report Hour </th>
                <th className="px-4 py-3">Amount </th>
                <th className="px-4 py-3">Won Amount </th>
                <th className="px-4 py-3">Ggr </th>
                <th className="px-4 py-3">Ggr Perc </th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
              {hourlystats.map((hourlystat) => {
                return (
                  <tr
                    key={hourlystat.id}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    <td className="px-4 py-5">{hourlystat.id}</td>
                    <td className="px-4 py-3 text-sm">
                      {hourlystat.report_date}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {hourlystat.report_hour}
                    </td>
                    <td className="px-4 py-3 text-sm">{hourlystat.amount}</td>
                    <td className="px-4 py-3 text-sm">
                      {hourlystat.won_amount}
                    </td>
                    <td className="px-4 py-3 text-sm">{hourlystat.ggr}</td>
                    <td className="px-4 py-3 text-sm">{hourlystat.ggr_perc}</td>
                    <td className="flex px-4 py-3 text-sm"></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Paginator lastPage={lastPage} pageChanged={setPage} />
      </div>
    </Wrapper>
  );
};
export default Hourlystats;
